export default __webpack_public_path__ + "static/media/Xiaomi Redmi Note 8 Pro.4b31fecd.png";